var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTitlePage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10a1 1 0 00-1 1c0 .637.145 1.83.533 3.28.389 1.45 1 3.08 2.13 4.3 1.29 1.39 2.79 2.28 4.14 2.81.822.325 1.55.511 2.2.602v8.01a1 1 0 102 0v-8c.672-.084 1.44-.274 2.3-.615 1.35-.531 2.85-1.42 4.14-2.81 1.12-1.21 1.74-2.85 2.13-4.3.389-1.45.533-2.64.533-3.28a1 1 0 00-1-1c-.664 0-1.69.148-2.9.574-1.21.426-2.58 1.14-3.68 2.33-1.03 1.11-1.87 2.48-2.47 3.88-.597-1.39-1.43-2.76-2.46-3.88-1.1-1.19-2.47-1.91-3.68-2.33s-2.24-.574-2.9-.574zm1.21 2.25c.377.072.574.05 1.03.211.991.349 2.07.929 2.88 1.8 1.37 1.48 2.25 3.78 2.61 5.52-.429-.08-.65-.042-1.2-.258a9.402 9.402 0 01-3.41-2.31c-.737-.796-1.32-2.18-1.66-3.46-.188-.699-.182-.986-.254-1.51zm15.7 0c-.071.52-.066.806-.254 1.51-.343 1.28-.925 2.66-1.66 3.46a9.427 9.427 0 01-3.41 2.31c-.547.216-.768.177-1.2.258.36-1.73 1.24-4.03 2.62-5.52.811-.876 1.89-1.46 2.88-1.8.455-.16.652-.139 1.03-.211z"
  })));
}

export default SvgTitlePage;